import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { NoDataParent, NoDataContainer, NoDataTextContainer, NoDataTitle, NoDataText, NoDataImage } from "./NoDataCardView.styles";
import { HXButton } from "./HXButton";
import { FlexRowDiv } from "./common.styles";
export const NoDataCardView = (props) => {
    const { title, text, addParentPadding, margin, buttons } = props;
    return (_jsx(NoDataParent, { addPadding: addParentPadding === true, margin: margin, children: _jsxs(NoDataContainer, { children: [props.image && _jsx(NoDataImage, { src: props.image }), _jsxs(NoDataTextContainer, { children: [title && _jsx(NoDataTitle, { children: title }), text && _jsx(NoDataText, { children: text })] }), buttons && (_jsx(FlexRowDiv, { gap: 24, children: buttons.map((button) => (_jsx(HXButton, { ...button }))) }))] }) }));
};
